import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { userLoginAsync } from '../../../redux/asyncActions/authAsyncActions';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { Background, Logo, TextLogo } from '../../index';
import Footer from '../../Footer';
const Link = require('react-router-dom').Link;

function Login() {
  const authObj = useSelector((state) => state.auth);
  const { userLoginLoading, loginError } = authObj;
  const dispatch = useDispatch();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  let navigate = useNavigate();
  const authLogin = async (e) => {
    e.preventDefault();
    if (!(email && password)) {
      setError(true);
      return;
    }

    const users = JSON.parse(localStorage.getItem('users')) || [];
    const user = users.find((user) => {
      const { firstName, lastName, email, phoneNumber } = user;
      localStorage.setItem(
        'loggedInUserData',
        JSON.stringify({ firstName, lastName, email, phoneNumber })
      );
      return user.email == email && user.password == password;
    });

    if (!user) {
      alert('Invalid Credentials');
    } else {
      navigate('/dashboard');
    }
    //dispatch(userLoginAsync({ email: email, password: password }));
  };

  return (
    <div className='login p-4'>
      <div className='row'>
        <div className='container'>
          <div className='pb-3 d-flex justify-content-center align-items-center flex-column'>
            <div className='p-2'>
              <Logo width='100' />
            </div>
            <div className='pt-2 text-center text-logo'>
              {/* <TextLogo /> */}
              <h4 className='mb-0'>HealthCare Platform&nbsp;</h4>
            </div>
            {/* <div className="slogan pt-4 text-center">
              <h4 className="mb-0">Reopen Schools&nbsp;</h4>
              <h4 className="mb-0">the Safe Way</h4>
            </div> */}
          </div>
          <div className='pt-3 row justify-content-center align-items-center'>
            <div className='col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5'>
              <Form>
                <Form.Group controlId='formEmail'>
                  <Form.Control
                    type='email'
                    size='lg'
                    className='input-rounded border mb-3'
                    placeholder='E-mail Address'
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {error && !email && (
                    <Form.Text className='small help-block text-danger'>
                      Username is required
                    </Form.Text>
                  )}
                </Form.Group>
                <Form.Group controlId='formPassword'>
                  <Form.Control
                    type='password'
                    size='lg'
                    className='input-rounded border mb-3'
                    placeholder='Password'
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  {error && !password && (
                    <Form.Text className='small help-block text-danger'>
                      Password is required
                    </Form.Text>
                  )}
                </Form.Group>
                {loginError && (
                  <div className='text-danger mt-2 mb-2 text-center'>
                    {loginError}
                  </div>
                )}
                <button
                  className='btn button-secondary btn-rounded btn-block btn-lg mb-3'
                  disabled={userLoginLoading}
                  onClick={authLogin}
                  type='submit'
                >
                  {userLoginLoading ? (
                    <div className='d-flex align-items-center justify-content-center'>
                      <Spinner
                        animation='border'
                        size='sm'
                        variant='light'
                        className='mr-2'
                      />
                      please wait...
                    </div>
                  ) : (
                    'Login'
                  )}
                </button>
                <Link
                  className='btn button-primary btn-rounded btn-block btn-lg'
                  disabled={userLoginLoading}
                  to='/registration'
                >
                  Create Account
                </Link>
                <Form.Group className='mb-0'>
                  <Link
                    to='/forgot'
                    className='nav-item nav-link pt-4 text-center txt-secondary'
                  >
                    Forgot Password?
                  </Link>
                </Form.Group>
              </Form>
            </div>
          </div>
          <div className='pt-3 row justify-content-center align-items-center'>
            <div className='col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5'>
              {/* <Footer /> */}
            </div>
          </div>
        </div>
      </div>
      {/* <Background path1={false} path2={false} /> */}
    </div>
  );
}

export default Login;